import { render, staticRenderFns } from "./printYCPurchases.vue?vue&type=template&id=459491a4&scoped=true&"
import script from "./printYCPurchases.vue?vue&type=script&lang=js&"
export * from "./printYCPurchases.vue?vue&type=script&lang=js&"
import style0 from "./printYCPurchases.vue?vue&type=style&index=0&id=459491a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459491a4",
  null
  
)

component.options.__file = "printYCPurchases.vue"
export default component.exports